// include short functions that are unique to this site here
rkt.CSS.nonCommonFunction = function(){
	console.log("nonCommonFunction")
}

// put long functions that are unique to this site in external files and require() them
rkt.CSS.largeNonCommonFunction = require('./largeNonCommonFunction')



// WEBPACK FOOTER //
// source/js/css/_index.js